import { Blogs, ShowCaseList, ShowCaseItemList, ShowcaseCategoryList, ShowcaseCategoryLevel1List, ShowcaseItemAttributeList, AdList } from './zod-types';

import axios, { AxiosRequestConfig } from "axios";
import { Quote, QuoteList } from '@/models/quote';
import { Case, CaseList } from '@/models/case';
import { NavigationMenu } from '@/models/navigation';
import { PriceList } from '@/models/product';
import { StaffList, User, WhoAmI } from './modal';


const GetRequestVerificationToken = () => {
    return axios.get(`${process.env.REACT_APP_BASE_URL}/_layout/tokenhtml/`, { responseType: 'document' })
}

const GetPatchPostHeaders = () => {
    const token = document.querySelector('#x-token') as HTMLInputElement
    const headers: AxiosRequestConfig['headers'] = {
        'content-type': 'application/json',
        '__RequestVerificationToken': token?.value || ''
    }
    return headers
}

const GetUser = async () => {
    const res = await axios.get<WhoAmI>(`${process.env.REACT_APP_BASE_URL}/api/v1/auth/whoami/`)
    return res.data
}


const PatchUser = (user: User) => {
    let data = {
        firstname: user.firstname,
        lastname: user.lastname,
        emailaddress1: user.email,
        mobilephone: user.mobile,
        telephone1: user.mainphone
    }
    return axios.patch(`${process.env.REACT_APP_BASE_URL
        }contacts(${user.id
        })`, JSON.stringify(data), { "headers": GetPatchPostHeaders() })
}

const GetStaff = () => {
    return axios.get<StaffList>(`${process.env.REACT_APP_BASE_URL}/api/v1/staff/`)
}

const GetQuotes = () => {
    return axios.get<QuoteList>(`${process.env.REACT_APP_BASE_URL}/api/v1/auth/quotations/`)
}

const GetQuote = (id: string) => {
    return axios.get<Quote>(`${process.env.REACT_APP_BASE_URL}/api/v1/auth/quotations/?id=${id}`)
}

const GetCases = () => {
    return axios.get<CaseList>(`${process.env.REACT_APP_BASE_URL}/api/v1/auth/cases/`)
}

const GetCase = (id: string) => {
    return axios.get<Case>(`${process.env.REACT_APP_BASE_URLL}/api/v1/auth/cases/?id=${id}`)
}

const GetBlogs = () => {
    return axios.get<Blogs>(`${process.env.REACT_APP_BASE_URL}/api/v1/blog/`)
}

const GetBlog = (url: string) => {
    return axios.get<Blogs>(`${process.env.REACT_APP_BASE_URL}/api/v1/blog/?partialurl=${url}`)
}
// 20251109
const GetCaseStudy = (url: string) => {
    // Use the categoryid for Case Studies
    return axios.get<Blogs>(
        `${process.env.REACT_APP_BASE_URL}/api/v1/blog/?partialurl=${url}&categoryid=e023fe3f-6174-ee11-8179-0022489338ed`
    );
};
// 20251109 end

const GetPriceList = (id: string, page: number | undefined) => {

    const query = page ? `?id=${id}&page=${page}` : `?id=${id}`

    return axios.get<PriceList>(`${process.env.REACT_APP_BASE_URL}/api/v1/auth/pricelist/${query}`)
}

const GetShowcaseItems = () => {
    return axios.get<ShowCaseItemList>(`${process.env.REACT_APP_BASE_URL}/api/v1/webshowcaseitem/`);
};
const GetShowcaseItemAttributes = () => {
    return axios.get<ShowcaseItemAttributeList>(`${process.env.REACT_APP_BASE_URL}/api/v1/productattribute/`);   
};

const GetShowcases = () => {
    return axios.get<ShowCaseList>(`${process.env.REACT_APP_BASE_URL}/api/v1/webshowcase/`);
};

const GetShowcaseCategories = () => {
    return axios.get<ShowcaseCategoryList>(`${process.env.REACT_APP_BASE_URL}/api/v1/showcasecategory/`);
};
const GetShowcaseCategoriesLevel1 = () => {
    return axios.get<ShowcaseCategoryLevel1List>(`${process.env.REACT_APP_BASE_URL}/api/v1/showcasecategorylevel1/`);
}
 

 const GetAds = () => {
    return axios.get<AdList>(`${process.env.REACT_APP_BASE_URL}/api/v1/ad/`);
};

const GetNavigation = async (name: string) => {
    const res = await axios.get<NavigationMenu>(`${process.env.REACT_APP_BASE_URL}/api/v1/nav/?name=${name}`)
    return res.data
}

const GetFooter = () => {
    return GetNavigation("Footer")
}


interface PageContent {
    status: string;
    statuscode: number;
    result: {
        id: string;
        name: string;
        content: string;
    };
}

const GetPageContent = (id: string) => {
    return axios.get<PageContent>(`${process.env.REACT_APP_BASE_URL}/api/v1/page/?id=${id}`)
}

export {
    GetRequestVerificationToken,
    GetUser,
    PatchUser,
    GetQuotes,
    GetQuote,
    GetCases,
    GetCase,
    GetPriceList,
    GetNavigation,
    GetPageContent,
    GetBlogs,
    GetBlog,
    GetCaseStudy,
    GetStaff,
    GetFooter,
    GetShowcaseItems,
    GetShowcases,
    GetShowcaseCategories,
    GetShowcaseCategoriesLevel1,
    GetShowcaseItemAttributes,
    GetAds
    
}

